'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HUMAN = exports.HUMAN = 'HUMAN';
var BOT = exports.BOT = 'BOT';